export default "__VITE_ASSET__CJ$hZFj___"